// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-53908be6] {\n  max-height: calc(100vh - 340px) !important;\n}\n.tr-suspended td[data-v-53908be6] {\n  background: #fff6f6 !important;\n}\ntd[data-v-53908be6] {\n  max-height: 50px !important;\n}\n.cell-title[data-v-53908be6] {\n  min-width: 400px;\n}\n.cell-address[data-v-53908be6] {\n  min-width: 220px;\n}\n.cell-phone[data-v-53908be6] {\n  white-space: nowrap;\n}\n.cell-updated-at[data-v-53908be6] {\n  min-width: 90px;\n}", ""]);
// Exports
module.exports = exports;
